export default __webpack_public_path__ + "static/media/memorable.68a819ab.png";